export const createMenuHTML = (menus) => {
  const container = document.createElement('div');
  container.id = 'menu-mesh';
  container.className = 'menu-mesh-wrapper';
  container.style.height = `${60 + 36 * menus.length}px`;

  const header = document.createElement('div');
  header.className = 'menu-mesh-header';
  header.innerHTML = 'Menu';

  const content = document.createElement('div');
  content.className = 'menu-mesh-content';

  const itemRefArr = [];
  menus.forEach((menu) => {
    const menuItem = document.createElement('div');
    menuItem.className = 'menu-mesh-item';
    menuItem.innerHTML = menu.title;
    itemRefArr.push(menuItem);
    content.appendChild(menuItem);
  });

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(container);
  return { html: container, itemRefArr };
};

export const createFlowsMenuHTML = (menus) => {
  const container = document.createElement('div');
  container.id = 'menu-mesh';
  container.className = 'menu-mesh-wrapper';
  container.style.height = `${60 + 36 * menus.length}px`;

  const header = document.createElement('div');
  header.className = 'menu-mesh-header';
  header.innerHTML = 'Menu';

  const content = document.createElement('div');
  content.className = 'menu-mesh-content';

  const itemRefArr = [];
  menus.forEach((menu, index) => {
    const menuItem = document.createElement('div');
    menuItem.className = 'menu-mesh-item';
    menuItem.innerHTML = menu.name;
    menuItem.dataset.indexNumber = index;
    if (index === 0) menuItem.style.backgroundColor = 'blue';
    itemRefArr.push(menuItem);
    content.appendChild(menuItem);
  });

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(container);
  return { html: container, itemRefArr };
};

export const createFlowsBarHTML = () => {
  const container = document.createElement('div');
  container.id = 'flows-bar';
  container.className = 'flows-bar';
  // container.style.height = `${60 + 36 * menus.length}px`;

  const info = document.createElement('div');
  info.className = 'flows-bar-info';

  const title = document.createElement('span');
  title.className = 'flows-bar-title';
  title.innerHTML = 'Title';

  const description = document.createElement('span');
  description.className = 'flows-bar-description';
  description.innerHTML =
    'This is a test message, change this this is a test message, this  is a test message, change thisThis is a test message, change This is a test message, change this this is a test message';

  info.appendChild(title);
  info.appendChild(description);

  const buttonBack = document.createElement('div');
  buttonBack.className = 'flows-bar-button flows-bar-button-wide';

  const buttonBackText = document.createElement('span');
  buttonBackText.innerHTML = 'Back';
  buttonBack.appendChild(buttonBackText);

  const buttonNext = document.createElement('div');
  buttonNext.className = 'flows-bar-button flows-bar-button-wide';

  const buttonNextText = document.createElement('span');
  buttonNextText.innerHTML = 'Next';
  buttonNext.appendChild(buttonNextText);

  const buttonTeleport = document.createElement('div');
  buttonTeleport.className = 'flows-bar-button flows-bar-button-wide';

  const buttonTeleportText = document.createElement('span');
  buttonTeleportText.innerHTML = 'Teleport';
  buttonTeleport.appendChild(buttonTeleportText);

  const itemRefArr = [buttonBack, buttonNext, buttonTeleport];

  // menus.forEach((menu, index) => {
  //   const menuItem = document.createElement('div');
  //   menuItem.className = 'menu-mesh-item';
  //   menuItem.innerHTML = menu.name;
  //   menuItem.dataset.indexNumber = index;
  //   if (index === 0) menuItem.style.backgroundColor = 'blue';
  //   itemRefArr.push(menuItem);
  //   content.appendChild(menuItem);
  // });

  container.appendChild(info);
  container.appendChild(buttonBack);
  container.appendChild(buttonNext);
  container.appendChild(buttonTeleport);

  // buttonBack.outerHTML = ' <div class="flows-bar-button"><i class="fa-solid fa-arrow-left"/></div>';
  //
  // buttonTeleport.outerHTML =
  //   '<div class="flows-bar-button">' +
  //   ' <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
  //   '      <path\n' +
  //   '        d="M5.54069 11.998C5.54069 8.43063 8.43259 5.53874 11.9999 5.53874M5.54069 11.998C5.54069 15.5653 8.43259 18.4572 11.9999 18.4572M5.54069 11.998L3.69519 11.998M11.9999 5.53874C15.5673 5.53874 18.4592 8.43064 18.4592 11.998M11.9999 5.53874L11.9999 3.69324M11.9999 18.4572C15.5673 18.4572 18.4592 15.5653 18.4592 11.998M11.9999 18.4572L11.9999 20.3027M18.4592 11.998L20.3047 11.998M9.23169 11.998C9.23169 10.4691 10.471 9.22974 11.9999 9.22974C13.5288 9.22974 14.7682 10.4691 14.7682 11.998C14.7682 13.5269 13.5288 14.7662 11.9999 14.7662C10.471 14.7662 9.23169 13.5269 9.23169 11.998Z"\n' +
  //   '        stroke="#2055FF"\n' +
  //   '        strokeWidth="1.81195"\n' +
  //   '        strokeLinecap="round"\n' +
  //   '        strokeLinejoin="round"\n' +
  //   '      />\n' +
  //   '    </svg>' +
  //   '</div>';

  document.body.appendChild(container);
  return { html: container, itemRefArr };
};
